import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { Avatar } from 'src/game/components/shared/Avatar';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { BuddiesBakerScore } from './BuddiesBakerScore';
import { BuddiesMVP } from './BuddiesMVP';

export type BuddiesRankingEntryParams = {
  name: string;
  photo: string;
  score: number;
  mvp?: boolean;
};

export class BuddiesRankingEntry extends View {
  private bg: ImageScaleView;
  private avatar: Avatar;
  private name: LangBitmapFontTextView;
  private score: BuddiesBakerScore;
  private mvp: BuddiesMVP;

  constructor(opts: ViewOpts) {
    super({
      width: 700,
      height: 92,
      ...opts,
    });

    this.bg = new ImageScaleView({
      superview: this,
      width: this.style.width,
      height: this.style.height + 4,
      image: 'assets/ui/match2/common/list_entry.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 30, right: 30 },
        vertical: { top: 30, bottom: 30 },
      },
    });

    this.avatar = new Avatar({
      superview: this,
      width: 70,
      height: 70,
      x: 50,
      y: this.style.height * 0.5 - 3,
      centerOnOrigin: true,
    });

    this.name = new LangBitmapFontTextView({
      superview: this,
      x: 90,
      y: -2,
      align: 'left',
      verticalAlign: 'center',
      size: 30,
      font: 'Body',
      width: 240,
      height: this.style.height,
      color: '#78263E',
    });

    this.score = new BuddiesBakerScore({
      superview: this,
      x: this.style.width - 90,
      y: this.style.height / 2,
    });

    this.mvp = new BuddiesMVP({
      superview: this,
      x: 15,
      y: 15,
      centerOnOrigin: true,
      visible: false,
    });
  }

  public setup(params: BuddiesRankingEntryParams) {
    this.name.localeText = () => params.name;
    this.name.updateOpts({ y: 0 });
    this.avatar.updateImage(params.photo);

    this.bg.updateOpts({
      image: 'assets/ui/match2/common/list_entry.png',
      offsetY: 0,
      height: this.style.height + 4,
    });
    this.name.updateOpts({
      font: 'Body',
      color: '#78263E',
    });

    this.score.setScore(params.score, 0);

    this.mvp.updateOpts({
      visible: !!params.mvp,
    });
  }
}
